import { defineContent } from './defineContent.js';
import data from './team.json';
import { teamSchema } from './team.schema.js';

export const team = defineContent(teamSchema, data);
